/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import vm from "../../main.js";

import pouch from "@/db/pouch";

export default {
  addHarvest({ commit }, harvest) {
    return new Promise(async (resolve, reject) => {
      try {
        return await pouch.c(harvest, false).then((co) => {
          if (co.ok) {
            return resolve("Harvest successfully registered");
          }
          return reject(co.message);
        });
      } catch (e) {
        return reject(e);
      }
    });
  },
  updateHarvest({ commit }, harvest) {
    console.log("Update Harvest not available");
    // return new Promise(async (resolve, reject) => {
    //   return await pouch
    //     .f({
    //         selector: {
    //           _id: harvest._id,
    //           z: 9,
    //         },
    //       },
    //       true,
    //       false
    //     )
    //     .then(async (sr) => {
    //       if (sr.hasOwnProperty("a")) {
    //         return await pouch
    //           .c(harvest, false)
    //           .then((ct) => {
    //             if (ct.ok) {
    //               return resolve("Harvest successfully updated");
    //             }
    //             return reject(ct.message);
    //           })
    //           .catch((e) => reject(e));
    //       } else {
    //         return reject(
    //           "This harvest has not been found. It might no longer exist in your database."
    //         );
    //       }
    //     });
    // });
  },
};
